import React from 'react'
import { cn } from './cn'

type PanelTag = 'div' | 'section' | 'aside' | 'article'

export interface PanelProps extends React.HTMLAttributes<HTMLElement> {
  /** 容器標籤；現有用法有 div / section / aside（語意不同，由呼叫端指定） */
  as?: PanelTag
  /** .panel-plain：背景改 --bg（移除 surface 底色） */
  plain?: boolean
}

/**
 * 卡片容器（.panel）：封裝各頁手寫的 `<div className="panel">`／`<section>`／`<aside>`。
 * style / data-* / aria-* 等屬性透傳，零視覺差。
 */
export function Panel({ as = 'div', plain, className, ...rest }: PanelProps) {
  const Tag = as as React.ElementType
  return <Tag className={cn('rounded-[var(--radius-lg)] border border-border bg-surface p-[var(--inset-panel)]', plain && 'bg-background', className)} {...rest} />
}

export type PanelGridProps = React.HTMLAttributes<HTMLDivElement>

/** 兩欄面板格線（.panel-grid）：包住多個 <Panel>。 */
export function PanelGrid({ className, ...rest }: PanelGridProps) {
  return <div className={cn('grid grid-cols-2 gap-[var(--gap-md)] max-[920px]:grid-cols-1', className)} {...rest} />
}
